import { render, staticRenderFns } from "./cookie-banner.vue?vue&type=template&id=0e31a248&scoped=true&"
import script from "./cookie-banner.vue?vue&type=script&lang=js&"
export * from "./cookie-banner.vue?vue&type=script&lang=js&"
import style0 from "./cookie-banner.vue?vue&type=style&index=0&id=0e31a248&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e31a248",
  null
  
)

/* custom blocks */
import block0 from "./cookie-banner-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Flayout%2Fcomponents%2Fcookie-banner.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog})
